import axios from 'axios';
import { HEADER_GDP_APP_NAME } from 'lib/constants';

export default async function generateToken(config) {
  const { endpoints, publicKeys } = config;
  const generateTokenUrl = `${endpoints.utilsApi}/authenticate`;

  return axios({
    url: generateTokenUrl,
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      appName: HEADER_GDP_APP_NAME,
      apiKey: publicKeys.utilsApiKey,
    },
  })
    .then(response => response.data)
    .catch(error => {
      console.error('GenerateToken Error: ', error);
      return error;
    });
}
